module.exports = __webpack_public_path__ + "static/media/react-it.7ebc32ec.png";